<template>
  <ContentWrap
    ><el-form inline class="-mb-15px"
      ><el-form-item label="活动"
        ><el-select v-model="activityId" filterable class="!w-320px" @change="load"
          ><el-option
            v-for="a in activities"
            :key="a.id"
            :label="a.title"
            :value="a.id" /></el-select
      ></el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="!activityId" @click="open()">
          <Icon icon="ep:plus" />添加工作人员
        </el-button>
      </el-form-item></el-form
    ><el-table :data="list" v-loading="loading" border
      ><el-table-column prop="memberId" label="会员ID" /><el-table-column label="角色"
        ><template #default="s">{{
          s.row.role === 2 ? '现场主管' : '核销员'
        }}</template></el-table-column
      ><el-table-column label="状态"
        ><template #default="s"
          ><el-tag :type="s.row.status === 0 ? 'success' : 'info'">{{
            s.row.status === 0 ? '启用' : '停用'
          }}</el-tag></template
        ></el-table-column
      ><el-table-column label="操作"
        ><template #default="s"
          ><el-button link type="primary" @click="open(s.row)">编辑</el-button
          ><el-button link type="danger" @click="remove(s.row.id)">删除</el-button></template
        ></el-table-column
      ></el-table
    ></ContentWrap
  ><Dialog v-model="visible" :title="form.id ? '编辑工作人员' : '添加工作人员'" width="480px"
    ><el-form :model="form" label-width="100px"
      ><el-form-item label="会员ID"
        ><el-input-number v-model="form.memberId" :min="1" /></el-form-item
      ><el-form-item label="角色"
        ><el-radio-group v-model="form.role"
          ><el-radio :value="1">核销员</el-radio
          ><el-radio :value="2">现场主管</el-radio></el-radio-group
        ></el-form-item
      ><el-form-item label="状态"
        ><el-switch
          v-model="form.status"
          :active-value="0"
          :inactive-value="1" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="visible = false">取消</el-button
      ><el-button type="primary" @click="save">保存</el-button></template
    ></Dialog
  >
</template>
<script setup lang="ts">
import * as StaffApi from '@/api/activity/staff'
import * as ActivityApi from '@/api/activity/activity'
const message = useMessage()
const activities = ref<any[]>([]),
  list = ref<any[]>([]),
  activityId = ref<number>(),
  loading = ref(false),
  visible = ref(false)
const form = reactive<any>({ id: undefined, memberId: undefined, role: 1, status: 0 })
const load = async () => {
  if (!activityId.value) return
  loading.value = true
  try {
    list.value = (await StaffApi.getStaffList(activityId.value)) || []
  } finally {
    loading.value = false
  }
}
const open = (row?: any) => {
  Object.assign(form, row || { id: undefined, memberId: undefined, role: 1, status: 0 })
  visible.value = true
}
const save = async () => {
  const data = { ...form, activityId: activityId.value, permissionJson: '["checkin"]' }
  form.id ? await StaffApi.updateStaff(data) : await StaffApi.createStaff(data)
  message.success('保存成功')
  visible.value = false
  load()
}
const remove = async (id: number) => {
  await message.confirm('确定删除该工作人员？')
  await StaffApi.deleteStaff(id)
  load()
}
onMounted(async () => {
  activities.value = (await ActivityApi.getActivityListAll()) || []
  if (activities.value.length) {
    activityId.value = activities.value[0].id
    load()
  }
})
</script>
